import { canIn } from "./permissions";
import type { CurrentUser, OrganizationMembership } from "./types";

/** The organizations whose data is in view, in the switcher's order. */
export function organizationsInView(user: CurrentUser | null): OrganizationMembership[] {
  if (!user) return [];
  return user.organizations.filter((o) => user.organizationIds.includes(o.id));
}

/** Organizations in view where the person holds the permission (e.g. where they may create something). */
export function organizationsWhere(user: CurrentUser | null, permission: string): OrganizationMembership[] {
  return organizationsInView(user).filter((o) => canIn(user, permission, o.id));
}

/** True when several organizations are in view, so items should show which one they belong to. */
export function isCombinedView(user: CurrentUser | null): boolean {
  return (user?.organizationIds.length ?? 0) > 1;
}

export function organizationName(user: CurrentUser | null, organizationId: string): string {
  return user?.organizations.find((o) => o.id === organizationId)?.name ?? "";
}
